import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Player from "../../../../components/Player";
import Slider from "rc-slider";
import {Button} from "../../../../components/Button";
import "./CoverFromPlayer.scss"
import {updateCoverVideoFfmpeg} from "../../../../../creators/media";




class CoverFromPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pos : 0,
            isLoading : false,
            internalPlayer : null
        }
        this.setRefPlayer = this.setRefPlayer.bind(this);
        this.handlePosition = this.handlePosition.bind(this);
    }

    componentWillUnmount() {
        let internalPlayer = this.state.internalPlayer;
        if(internalPlayer){
            internalPlayer.removeEventListener('play', ()=>{
                internalPlayer.pause();
            });
        }
    }

    setRefPlayer(player) {
        if(player){
            this.setState({internalPlayer : player, isLoading : true});
            player.addEventListener('play', ()=>{
                player.pause();
            });
        }
    }

    handlePosition(pos){
        let internalPlayer = this.state.internalPlayer;
        if(internalPlayer){
            this.setState({pos});
            let duration = internalPlayer.duration;
            let newTime = duration * pos / 100;
            internalPlayer.currentTime = newTime
        }
    }

    onSubmit(){
        let internalPlayer = this.state.internalPlayer;
        if(internalPlayer){
            let currentTime = internalPlayer.currentTime;
            currentTime = parseInt(currentTime * 1000);
            //call l'api
            this.props.updateCoverVideoFfmpeg(this.props.media._id, {currentTime});
            this.props.handleClose();
        }
    }


    render() {

        return (
            <div id="cover-from-player">
                <Player media={this.props.media} setRefPlayer={this.setRefPlayer} controls={false} muteStrength={true} />
                {this.state.internalPlayer ?
                    <div className={"controls"}>
                        <Slider
                            min={0}
                            max={100}
                            step={1}
                            defaultValue={this.state.pos}
                            value={this.state.pos}
                            onChange={(pos)=> this.handlePosition(pos)}
                        />
                        <div className={"btn-group"}>
                            <Button size={"small"}
                                    btnStyle={"grey"}
                                    onClick={() => this.props.goBack()}
                                    content={"Annuler"}
                            />
                            <Button size={"small"}
                                btnStyle={"primary-reverse"}
                                className={"ml-8"}
                                onClick={() => this.onSubmit()}
                                content={"Utiliser cette image en couverture"}
                            />
                        </div>

                    </div>
                    : <div className={"btn-group"}>
                        <p className={"text-danger"}>{this.state.isLoading ? "Impossible de charger la vidéo" : ""}</p>
                        <Button size={"small"}
                                btnStyle={"grey"}
                                onClick={() => this.props.goBack()}
                                content={"Annuler"}
                        />
                    </div>}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserInitialized : state.currentUser.initialized,
        currentUserLoading : state.currentUser.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateCoverVideoFfmpeg
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CoverFromPlayer);